import { useMediaQuery } from "@mui/material";

/**
 * What to pass to MUI's `Skeleton` `animation` prop (EB-543).
 *
 * A loading screen is a large field of simultaneously moving shapes — close to the worst case
 * `prefers-reduced-motion` exists to prevent. Switched off, the grey blocks still do the job that
 * matters: reserving the space the real content will occupy.
 */
export const useSkeletonAnimation = (): "wave" | false => {
  const prefersReducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");

  return prefersReducedMotion ? false : "wave";
};
